import React, { useEffect, useState } from 'react';
import {
    Box, Grid, TextField, Button, Typography, Paper,
    InputAdornment, Container, MenuItem
} from "@mui/material";
import {
    MailOutline,
} from "@mui/icons-material";
import { isValidName, validateMessage, validatePhone, validateEmail } from "../../shared/validation";
import { sendContactUs } from "../../apiCalls/urlFunction";
import CircularProgress from "@mui/material/CircularProgress";


const COLORS = {
    darkBlue: "#001e4d",
    lightBlue: "#00b8e6",
    white: "#ffffff",
    border: "#e0e0e0",
    infoBorder: "rgba(255, 255, 255, 0.2)"
};

const FONT_FAMILY = "Be Vietnam Pro";

function ContactUsForm() {
    const [formData, setFormData] = useState({
        firstName: '', lastName: '', email: '', mobile: '', message: ''
    });
    const [loading, setLoading] = useState(false);
    const [clickCount, setClickCount] = useState(0);
    const [isTemporarilyDisabled, setIsTemporarilyDisabled] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [messageType, setMessageType] = useState("");

    const [error, setError] = useState({
        firstNameError: { status: false, message: '' },
        lastNameError: { status: false, message: '' },
        emailError: { status: false, message: '' },
        mobileError: { status: false, message: '' },
        messageError: { status: false, message: '' }
    });
    const [countryCode, setCountryCode] = useState("+971");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const handleCountryChange = (e) => {
        setCountryCode(e.target.value);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "mobile") {
            const phone = value.replace(/\D/g, "").slice(0, 9);

            setFormData((prev) => ({
                ...prev,
                [name]: phone,
            }));
            return;
        }

        setFormData(prev => ({ ...prev, [name]: value }));
    };


    const handleFormSubmit = async (event) => {
        if (isTemporarilyDisabled) return;

        const newCount = clickCount + 1;
        setClickCount(newCount);

        if (newCount >= 2) {
            setIsTemporarilyDisabled(true);

            setTimeout(() => {
                setClickCount(0);
                setIsTemporarilyDisabled(false);
            }, 5000);
        }
        event.preventDefault();

        const errorObject = {
            firstNameError: { status: false, message: '' },
            lastNameError: { status: false, message: '' },
            emailError: { status: false, message: '' },
            mobileError: { status: false, message: '' },
            messageError: { status: false, message: '' }
        };

        let isValid = true;

        if (!isValidName(formData.firstName).status) {
            errorObject.firstNameError = { status: true, message: isValidName(formData.firstName).message };
            isValid = false;
        }
        if (!isValidName(formData.lastName).status) {
            errorObject.lastNameError = { status: true, message: isValidName(formData.lastName).message };
            isValid = false;
        }
        if (!validateEmail(formData.email).status) {
            errorObject.emailError = { status: true, message: validateEmail(formData.email).message };
            isValid = false;
        }
        if (!validatePhone(formData.mobile).status) {
            errorObject.mobileError = { status: true, message: validatePhone(formData.mobile).message };
            isValid = false;
        }
        if (!validateMessage(formData.message).status) {
            errorObject.messageError = { status: true, message: validateMessage(formData.message).message };
            isValid = false;
        }

        setError(errorObject);

        if (isValid) {
            const payload = {
                "firstName": `${formData.firstName}`,
                "lastName": `${formData.lastName}`,
                "email": formData.email,
                "phoneNumber": `${countryCode}${formData.mobile}`,
                "message": formData.message,
            };
            try {
                setLoading(true);
                await sendContactUs(payload)
                setMessageType("success");
                setSuccessMessage("Your message has been sent successfully!");

            } catch (error) {
                console.error(error);
                setMessageType("error");
                setErrorMessage("Failed to send message. Please try again.");
                setSuccessMessage("");
            }
            finally {
                setLoading(false);
            }

        }


    };

    return (
        <Box sx={{ py: { xs: 4, md: 8 }, fontFamily: FONT_FAMILY, minHeight: "100vh", display: 'flex', alignItems: 'center' }}>
            <Container maxWidth="xl">
                {/* Out of Box Header */}
                <Typography variant="h4" align="center" sx={{ fontFamily: FONT_FAMILY, color: COLORS.lightBlue, fontWeight: 600, mb: { xs: 4, md: 6 }, fontSize: { xs: '1.75rem', sm: '2.125rem' } }}>
                    Get in touch
                </Typography>

                {/* Master Responsive Grid Container */}
                <Grid container spacing={{ xs: 4, lg: 5 }} alignItems="stretch" justifyContent="center">


                    {/* Main Form Item */}
                    <Grid item xs={12} md={7} lg={8} sx={{ display: 'flex' }}>

                        <Paper
                            elevation={0}
                            sx={{
                                p: { xs: 2.5, sm: 4 },
                                borderRadius: '24px',
                                border: `1px solid ${COLORS.border}`,
                                bgcolor: COLORS.white,
                                width: "100%",
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between'
                            }}
                        >

                            <Box>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontFamily: FONT_FAMILY,
                                        color: COLORS.darkBlue,
                                        fontWeight: 700,
                                        mb: 1,
                                        fontSize: { xs: '1.25rem', sm: '1.5rem' },
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1
                                    }}

                                >
                                    Send us a message
                                </Typography>




                                <Typography variant="body2" sx={{ fontFamily: FONT_FAMILY, color: "#666", mb: 4 }}>
                                    Do you have a question? A complaint? Or need help? Feel free to contact us!
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography sx={labelStyle}>First Name</Typography>
                                        <TextField fullWidth placeholder="Enter first name" name="firstName" value={formData.firstName} onChange={handleChange} sx={inputStyles} error={error.firstNameError.status} helperText={error.firstNameError.message} FormHelperTextProps={{ sx: { fontFamily: FONT_FAMILY } }} />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography sx={labelStyle}>Last Name</Typography>
                                        <TextField fullWidth placeholder="Enter last name" name="lastName" value={formData.lastName} onChange={handleChange} error={error.lastNameError.status} helperText={error.lastNameError.message} sx={inputStyles} FormHelperTextProps={{ sx: { fontFamily: FONT_FAMILY } }} />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography sx={labelStyle}>Email</Typography>
                                        <TextField fullWidth placeholder="Enter email" name="email" value={formData.email} onChange={handleChange} sx={inputStyles} error={error.emailError.status} helperText={error.emailError.message} FormHelperTextProps={{ sx: { fontFamily: FONT_FAMILY } }} />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography sx={labelStyle}>Contact Details</Typography>
                                        <TextField
                                            fullWidth
                                            placeholder="Enter phone number"
                                            name="mobile"
                                            value={formData.mobile}
                                            onChange={handleChange}
                                            error={error.mobileError.status}
                                            helperText={error.mobileError.message}
                                            sx={inputStyles}
                                            FormHelperTextProps={{ sx: { fontFamily: FONT_FAMILY } }}
                                            InputProps={{
                                                maxLenght: 9,
                                                startAdornment: (
                                                    <InputAdornment position="start" sx={{ m: 0, pr: 1, borderRight: "1px solid #ddd" }}>
                                                        <TextField
                                                            select
                                                            value={countryCode}
                                                            onChange={handleCountryChange}
                                                            variant="standard"
                                                            InputProps={{ disableUnderline: true }}
                                                            sx={{
                                                                "& .MuiSelect-select": {
                                                                    fontFamily: FONT_FAMILY,
                                                                    fontWeight: 500,
                                                                    fontSize: "0.9rem",
                                                                    paddingRight: "12px !important"
                                                                }
                                                            }}
                                                        >
                                                            <MenuItem value="+971" sx={{ fontFamily: FONT_FAMILY }}>+971</MenuItem>

                                                        </TextField>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography sx={labelStyle}>Message</Typography>
                                        <TextField fullWidth multiline rows={4} placeholder="Enter message" name="message" value={formData.message} onChange={handleChange} error={error.messageError.status} helperText={error.messageError.message} sx={inputStyles} FormHelperTextProps={{ sx: { fontFamily: FONT_FAMILY } }} />
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ display: "flex", justifyContent: { xs: "center", sm: "flex-start" }, mt: 4 , mb:3}}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={handleFormSubmit}
                                    disabled={loading || isTemporarilyDisabled}
                                    sx={{ ...submitBtnStyle, width: { sm: 'auto' } }}
                                >
                                    {loading ? (
                                        <CircularProgress
                                            size={22}
                                            thickness={5}
                                            color="inherit"
                                        />
                                    ) : (
                                        "Send a message"
                                    )}
                                </Button>
                            </Box>
                              {messageType && (
                                <Typography
                                    sx={{
                                        mt:2,
                                        mb: 2,
                                        m:'auto',
                                        fontFamily: FONT_FAMILY,
                                        fontWeight: 500,
                                        color: messageType === "success" ? "success.main" : "error.main"
                                    }}
                                >
                                    {messageType === "success"
                                        ? successMessage
                                        : errorMessage}
                                </Typography>
                            )}
                        </Paper>
                    </Grid>

                    {/* Side Detail Box */}
                    <Grid item xs={12} md={5} lg={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                        <Box sx={{
                            bgcolor: COLORS.darkBlue,
                            borderRadius: '24px',
                            border: `1px solid ${COLORS.infoBorder}`,
                            p: { xs: 3, sm: 4, md: 5 },
                            color: COLORS.white,
                            width: "100%",
                            maxHeight: "400px",
                            maxWidth: { xs: '100%', md: '400px' },
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}>
                            <Typography variant="h6" sx={{ fontFamily: FONT_FAMILY, mb: 4, fontWeight: 500, fontSize: '1.2rem', textAlign: { xs: 'center', md: 'left' } }}>
                                Hi! we are always here to help you.
                            </Typography>

                            {/* RESTORED COMMENTED LINE */}
                            {/* <ContactItem icon={<HeadsetMic />} title="Hotline Support" detail="+9718742998998" /> */}

                            <ContactItem icon={<MailOutline />} title="Email" detail="support@99gift.ae" />
                            {/* <ContactItem icon={<Room />} title="Address" detail="Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E." /> */}

                            {/* RESTORED COMMENTED SOCIAL MEDIA BOX */}
                            {/* <Box sx={{ mt: 6, textAlign: "center" }}>
                                <Typography variant="body2" sx={{ fontFamily: FONT_FAMILY, mb: 2, opacity: 1, }}>Follow us on social media</Typography>
                                <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                                    <IconButton size="small" sx={{ color: COLORS.white, border: '1px solid rgba(255,255,255,0.2)' }}><Instagram /></IconButton>
                                    <IconButton size="small" sx={{ color: COLORS.white, border: '1px solid rgba(255,255,255,0.2)' }}><Facebook /></IconButton>
                                    <IconButton size="small" sx={{ color: COLORS.white, border: '1px solid rgba(255,255,255,0.2)' }}><LinkedIn /></IconButton>
                                </Box>
                            </Box> */}
                        </Box>
                    </Grid>

                </Grid>
            </Container>
        </Box>
    );
}

const ContactItem = ({ icon, title, detail }) => (
    <Box sx={{
        display: "flex", alignItems: "flex-start", p: 2, mb: 2.5, borderRadius: '15px',
        bgcolor: "rgba(255, 255, 255, 0.05)", border: "1px solid rgba(255, 255, 255, 0.08)"
    }}>
        <Box sx={{ mr: 2, mt: 0.2, color: COLORS.lightBlue, display: 'flex', alignItems: 'center' }}>{icon}</Box>
        <Box>
            <Typography variant="caption" sx={{ fontFamily: FONT_FAMILY, display: "block", opacity: 0.6, textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 }}>{title}</Typography>
            <Typography variant="body2" sx={{ fontFamily: FONT_FAMILY, fontWeight: 500, mt: 0.5, lineHeight: 1.4 }}>{detail}</Typography>
        </Box>
    </Box>
);

const labelStyle = { fontFamily: FONT_FAMILY, fontWeight: 600, mb: 0.5, fontSize: '0.85rem', color: '#333' };

const inputStyles = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '12px',
        backgroundColor: '#fafafa',
        fontFamily: FONT_FAMILY,
        '& input': { fontFamily: FONT_FAMILY },
        '& textarea': { fontFamily: FONT_FAMILY },
        '& fieldset': { borderColor: '#e0e0e0' },
        '&:hover fieldset': { borderColor: '#b0b0b0' },
        '&.Mui-focused fieldset': { borderColor: COLORS.lightBlue }
    },
    '& .MuiInputBase-input::placeholder': {
        fontFamily: FONT_FAMILY,
        opacity: 0.8
    }
};

const submitBtnStyle = {
    fontFamily: FONT_FAMILY, bgcolor: COLORS.darkBlue, px: 6, py: 1.5, borderRadius: '10px',
    textTransform: "none", fontWeight: 600, boxShadow: 'none',
    "&:hover": { bgcolor: "#003366", boxShadow: 'none' }
};

export default ContactUsForm;